module.exports = __webpack_public_path__ + "static/media/10-1.9e5c1278.mp3";